module.exports = __webpack_public_path__ + "static/media/icon-carbon-dark.04a54480.svg";